(function () {
  function h(tag, attrs, children) {
    const el = document.createElement(tag);
    attrs = attrs || {};
    Object.keys(attrs).forEach((k) => {
      if (k === 'class') el.className = attrs[k];
      else if (k === 'text') el.textContent = attrs[k];
      else if (k.indexOf('on') === 0) el.addEventListener(k.slice(2).toLowerCase(), attrs[k]);
      else el.setAttribute(k, attrs[k]);
    });
    (children || []).forEach((c) => { if (c) el.appendChild(c); });
    return el;
  }

  function dashImg(key, altText, className) {
    const src = window.DrinkLab.DASH_IMAGES && window.DrinkLab.DASH_IMAGES[key];
    if (!src) return null;
    return h('img', { class: `dl-dash-img ${className || ''}`.trim(), src, alt: altText, loading: 'lazy' });
  }

  function displayName(key) {
    return String(key || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  }

  // Groups used to organize/filter Search by Flavour results. 'dirty_soda'
  // is a pseudo-group (both custom_soda AND creamy compatibility) so those
  // 10 recipes get their own bucket instead of splitting oddly across two.
  const SEARCH_GROUPS = [
    { key: 'coffee', label: 'Café' },
    { key: 'custom_soda', label: 'Custom Soda' },
    { key: 'dirty_soda', label: 'Dirty Soda' },
    { key: 'lemonade', label: 'Lemonade' },
    { key: 'sparkling', label: 'Sparkling' },
    { key: 'creamy', label: 'Creamy' },
    { key: 'iced_tea', label: 'Iced Tea' },
    { key: 'mocktail', label: 'Mocktail' },
    { key: 'cocktail', label: 'Cocktail' }
  ];

  function searchGroupKey(recipe) {
    const dc = recipe.drinkCompatibility || {};
    if (dc.custom_soda && dc.creamy) return 'dirty_soda';
    return Object.keys(dc)[0];
  }

  function searchGroupLabel(key) {
    const found = SEARCH_GROUPS.find((g) => g.key === key);
    return found ? found.label : displayName(key);
  }

  function DrinkLabApp(root) {
    const Session = window.DrinkLab.Session;
    const Engine = window.DrinkLab.Engine;
    const Cart = window.DrinkLab.CartService;

    // Top-level view, independent of the quiz's own internal question
    // flow (which Session already tracks). 'landing' | 'quiz' | 'flavourSearch' | 'submit'.
    let currentView = 'landing';

    // Community recipe submissions: photos upload straight to Cloudinary
    // (unsigned preset — safe to expose; no account secret is used), then the
    // full submission is sent to Omnisend for review + follow-up.
    var CLOUDINARY_CLOUD = 'ght6h0tj';
    var CLOUDINARY_PRESET = 'drink-lab-submissions';

    // Search by Flavour is a separate discovery mode from the quiz, so it
    // keeps its own small state rather than living inside Session.intent.
    let flavourSearchState = { query: '', selectedKey: null, sugarFreeOnly: false, groupFilter: 'all' };
    function resetFlavourSearchState() {
      flavourSearchState = { query: '', selectedKey: null, sugarFreeOnly: false, groupFilter: 'all' };
    }

    function backHomeBar() {
      return h('button', { class: 'dl-home-bar', text: '← Drink Lab home', onclick: () => { currentView = 'landing'; Session.reset(); render(); } });
    }

    function render() {
      root.innerHTML = '';
      if (currentView === 'landing') { renderLandingScreen(); return; }
      if (currentView === 'flavourSearch') { renderFlavourSearchScreen(); return; }
      if (currentView === 'submit') { renderSubmitScreen(); return; }
      const session = Session.get();
      if (session.currentQuestionId === 'result') renderLoadingThenResult();
      else renderQuestion(session.currentQuestionId);
    }

    // ---------------- Landing: two entry paths ----------------
    function renderLandingScreen() {
      const q = window.DrinkLab.QUESTIONS.welcome;
      root.appendChild(h('div', { class: 'dl-welcome' }, [
        dashImg('welcome', 'Dash, the SIMPS goose scientist, holding a beaker and a "Taste. Test. Approve." clipboard', 'dl-dash-welcome'),
        h('h1', { text: q.title }),
        h('p', { class: 'dl-copy', text: q.copy }),
        h('p', { class: 'dl-sub', text: q.sub }),
        h('div', { class: 'dl-landing-paths' }, [
          h('button', { class: 'dl-cta dl-path-btn', text: 'FIND A DRINK', onclick: () => {
            currentView = 'quiz'; Session.reset(); render();
          } }),
          h('button', { class: 'dl-cta-secondary dl-path-btn', text: 'SEARCH BY FLAVOUR', onclick: () => {
            currentView = 'flavourSearch'; resetFlavourSearchState(); render();
          } })
        ]),
        h('p', { class: 'dl-landing-hint', text: 'Find a Drink: answer a few quick questions and Dash picks for you.\nSearch by Flavour: already have a SIMPS syrup? Find every recipe that uses it.' }),
        h('button', { class: 'dl-submit-link', text: 'Got your own recipe? Share it with the Lab →', onclick: () => { currentView = 'submit'; render(); } })
      ]));
    }

    // ---------------- Submit your recipe (community submissions) ----------------
    function renderSubmitScreen() {
      const wrap = h('div', { class: 'dl-submit' });
      wrap.appendChild(backHomeBar());
      wrap.appendChild(h('div', { class: 'dl-question-header' }, [
        dashImg('thinking', 'Dash ready to log your recipe', 'dl-dash-thinking'),
        h('div', { class: 'dl-question-header-text' }, [
          h('p', { class: 'dl-dash-copy', text: 'Invented something worth repeating? Send it in — Dash reviews every submission and the best ones join the Lab.' }),
          h('h2', { text: 'Submit your recipe' })
        ])
      ]));

      const form = h('div', { class: 'dl-submit-form' });
      function field(labelText, control, opts) {
        opts = opts || {};
        return h('label', { class: 'dl-field' }, [
          h('span', { class: 'dl-field-label', text: labelText + (opts.required ? ' *' : '') }),
          control,
          opts.hint ? h('span', { class: 'dl-field-hint', text: opts.hint }) : null
        ]);
      }
      const nameI = h('input', { type: 'text', class: 'dl-input', maxlength: '60', placeholder: 'e.g., Jamie R.' });
      const emailI = h('input', { type: 'email', class: 'dl-input', placeholder: 'you@email.com' });
      const igI = h('input', { type: 'text', class: 'dl-input', maxlength: '40', placeholder: '@yourhandle' });
      const recipeI = h('input', { type: 'text', class: 'dl-input', maxlength: '80', placeholder: 'e.g., Maple Pecan Cold Brew' });
      const typeSel = h('select', { class: 'dl-input' }, [['', 'Pick one…'], ['coffee', 'Café'], ['custom_soda', 'Soda'], ['dirty_soda', 'Dirty Soda'], ['lemonade', 'Lemonade'], ['sparkling', 'Sparkling'], ['creamy', 'Creamy'], ['iced_tea', 'Iced Tea'], ['mocktail', 'Mocktail'], ['cocktail', 'Cocktail']].map((o) => h('option', { value: o[0], text: o[1] })));
      const simpsI = h('input', { type: 'text', class: 'dl-input', maxlength: '120', placeholder: 'e.g., SIMPS Vanilla, LOCAL Orange Soda' });
      const ingredientsTA = h('textarea', { class: 'dl-input dl-textarea', rows: '5', maxlength: '1200', placeholder: 'One ingredient per line, with amounts.\n1 oz SIMPS Vanilla\n8 oz cold brew' });
      const stepsTA = h('textarea', { class: 'dl-input dl-textarea', rows: '5', maxlength: '1200', placeholder: 'How do you make it? One step per line.' });
      const photoI = h('input', { type: 'file', accept: 'image/png,image/jpeg,image/webp,image/heic', class: 'dl-file' });
      const consentCb = h('input', { type: 'checkbox' });
      const marketingCb = h('input', { type: 'checkbox' });

      form.appendChild(field('Your name', nameI, { required: true, hint: 'Shown as “Submitted by …” if we feature it.' }));
      form.appendChild(field('Email', emailI, { required: true, hint: 'So we can let you know if it makes the Lab.' }));
      form.appendChild(field('Instagram handle', igI, { hint: 'Optional — so we can tag you.' }));
      form.appendChild(field('Recipe name', recipeI, { required: true }));
      form.appendChild(field('Drink type', typeSel, { required: true }));
      form.appendChild(field('SIMPS products used', simpsI, { required: true, hint: 'Which SIMPS/LOCAL syrups or sodas star in it?' }));
      form.appendChild(field('Ingredients', ingredientsTA, { required: true }));
      form.appendChild(field('Steps', stepsTA, { required: true }));
      form.appendChild(field('Photo of your drink', photoI, { required: true, hint: 'JPG, PNG, WEBP or HEIC. Max 10 MB.' }));

      form.appendChild(h('label', { class: 'dl-check' }, [consentCb, h('span', { class: 'dl-check-box' }), h('span', { class: 'dl-check-text', text: 'I give SIMPS permission to feature my recipe and photo in the Drink Lab and its marketing. *' })]));
      form.appendChild(h('label', { class: 'dl-check' }, [marketingCb, h('span', { class: 'dl-check-box' }), h('span', { class: 'dl-check-text', text: 'Email me SIMPS drink ideas and updates.' })]));

      const status = h('p', { class: 'dl-submit-status' });
      const submitBtn = h('button', { class: 'dl-cta dl-submit-btn', text: 'SUBMIT RECIPE' });
      form.appendChild(status);
      form.appendChild(submitBtn);
      wrap.appendChild(form);
      root.appendChild(wrap);

      function fail(msg) { status.textContent = msg; status.className = 'dl-submit-status dl-submit-error'; }
      function sanitize(v) { return String(v || '').replace(/[|=\r\n]/g, ' ').trim().slice(0, 200); }

      submitBtn.addEventListener('click', async () => {
        status.className = 'dl-submit-status'; status.textContent = '';
        const name = nameI.value.trim(), email = emailI.value.trim(), recipe = recipeI.value.trim();
        const drinkType = typeSel.value;
        const drinkTypeLabel = (typeSel.options[typeSel.selectedIndex] && typeSel.options[typeSel.selectedIndex].text) || '';
        const ig = igI.value.trim(), simps = simpsI.value.trim(), ingredients = ingredientsTA.value.trim(), steps = stepsTA.value.trim();
        const file = photoI.files && photoI.files[0];
        if (!name || !email || !recipe || !drinkType || !simps || !ingredients || !steps) return fail('Please fill in all required fields (marked *).');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return fail('Please enter a valid email address.');
        if (!file) return fail('Please add a photo of your drink.');
        if (!/^image\//.test(file.type || '')) return fail('The photo needs to be an image file.');
        if (file.size > 10 * 1024 * 1024) return fail('That photo is over 10 MB — please use a smaller one.');
        if (!consentCb.checked) return fail('Please tick the permission box so we can feature your recipe.');

        submitBtn.disabled = true; submitBtn.textContent = 'UPLOADING…';

        let photoUrl = '';
        try {
          const fd = new FormData();
          fd.append('file', file);
          fd.append('upload_preset', CLOUDINARY_PRESET);
          fd.append('folder', 'drink_lab_submissions');
          fd.append('tags', 'drink-lab-submission');
          fd.append('context', 'recipe=' + sanitize(recipe) + '|by=' + sanitize(name) + '|email=' + sanitize(email) + '|type=' + sanitize(drinkTypeLabel) + '|products=' + sanitize(simps) + '|ig=' + sanitize(ig));
          const res = await fetch('https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/image/upload', { method: 'POST', body: fd });
          if (!res.ok) throw new Error('upload failed');
          const data = await res.json();
          photoUrl = data.secure_url || '';
          if (!photoUrl) throw new Error('no url');
        } catch (err) {
          submitBtn.disabled = false; submitBtn.textContent = 'SUBMIT RECIPE';
          return fail('Photo upload failed — please check your connection and try again.');
        }

        // Email the full submission (with the photo link) to the SIMPS inbox —
        // this is the instant notification + review surface. Best-effort;
        // Cloudinary has already captured everything if this call fails.
        try {
          await fetch('https://formsubmit.co/ajax/244b01a218feda92ccec64d87c49bb00', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              _subject: 'New Drink Lab recipe: ' + recipe,
              _template: 'table',
              _captcha: 'false',
              'Recipe name': recipe,
              'Submitted by': name,
              Email: email,
              Instagram: ig || '—',
              'Drink type': drinkTypeLabel,
              'SIMPS products': simps,
              Ingredients: ingredients,
              Steps: steps,
              'Consent given': 'Yes',
              'Marketing opt-in': marketingCb.checked ? 'Yes' : 'No',
              Photo: photoUrl
            })
          });
        } catch (e) { /* non-blocking */ }

        // Best-effort: send the full submission to Omnisend for review + follow-up.
        // Cloudinary has already captured the photo + key details, so a failure
        // here never loses the submission or blocks the success screen.
        try {
          window.omnisend = window.omnisend || [];
          if (typeof window.omnisend.identifyContact === 'function') window.omnisend.identifyContact({ email: email, firstName: name });
          else window.omnisend.push(['identifyContact', { email: email, firstName: name }]);
          const props = { email: email, name: name, instagram: ig, recipeName: recipe, drinkType: drinkTypeLabel, simpsProducts: simps, ingredients: ingredients, steps: steps, photoUrl: photoUrl, consent: true, marketingOptIn: !!marketingCb.checked };
          window.omnisend.push(['track', 'drink lab recipe submitted', { origin: 'api', properties: props }]);
        } catch (e) { /* non-blocking */ }

        wrap.innerHTML = '';
        wrap.appendChild(backHomeBar());
        wrap.appendChild(h('div', { class: 'dl-submit-success' }, [
          dashImg('success', 'Dash celebrating your recipe submission', 'dl-dash-success'),
          h('h2', { text: 'Recipe received!' }),
          h('p', { class: 'dl-copy', text: 'Thanks, ' + (name.split(' ')[0] || 'friend') + ' — Dash is reviewing it. If it makes the Lab, we’ll email you.' }),
          h('button', { class: 'dl-cta', text: 'BACK TO THE LAB', onclick: () => { currentView = 'landing'; render(); } })
        ]));
      });
    }

    function renderLabSettingsBar() {
      const session = Session.get();
      const checked = !!session.intent.sugarFreeOnly;
      const zeroToggle = h('div', { class: 'dl-zero-toggle' }, [
        h('span', { class: 'dl-zero-toggle-label', text: 'Zero Mode' }),
        h('label', { class: 'dl-switch' }, [
          h('input', Object.assign({ type: 'checkbox', onchange: (e) => { Session.setSugarFreeOnly(e.target.checked); } }, checked ? { checked: 'checked' } : {})),
          h('span', { class: 'dl-switch-track' }),
          h('span', { class: 'dl-switch-thumb' })
        ])
      ]);
      const startOver = h('button', { class: 'dl-start-over-link', text: 'Start over', onclick: () => { Session.reset(); render(); } });
      return h('div', { class: 'dl-settings-bar' }, [zeroToggle, h('span', {}, [startOver])]);
    }

    function renderCategoryGrid(options) {
      const grid = h('div', { class: 'dl-category-grid' });
      options.forEach((opt) => {
        const key = opt.set && opt.set.drinkType;
        const style = (window.DrinkLab.CATEGORY_STYLES && window.DrinkLab.CATEGORY_STYLES[key]) || {};
        const photoUrl = (window.DrinkLab.CATEGORY_ICON_URLS && window.DrinkLab.CATEGORY_ICON_URLS[key]) || style.imageUrl;
        const imageEl = photoUrl
          ? h('img', { class: 'dl-category-image-placeholder dl-category-image-real', src: photoUrl, alt: opt.label, loading: 'lazy' })
          : h('div', { class: 'dl-category-image-placeholder', text: style.icon || '🥤' });
        const card = h('button', { class: 'dl-category-card' }, [
          imageEl,
          h('span', { class: 'dl-category-label', text: opt.label }),
          style.copy ? h('span', { class: 'dl-category-copy', text: style.copy }) : null
        ]);
        if (style.bg) card.style.setProperty('--dl-card-bg', style.bg);
        if (style.accent) card.style.setProperty('--dl-card-accent', style.accent);
        card.addEventListener('click', () => { if (opt.set) Session.applyAnswer(opt.set); Session.goTo(opt.next); render(); });
        grid.appendChild(card);
      });
      return grid;
    }

    function renderQuestion(questionId) {
      const q = window.DrinkLab.QUESTIONS[questionId];
      if (!q) { root.appendChild(h('div', { text: 'Dash lost the recipe card. Please start over.' })); return; }

      const wrap = h('div', { class: 'dl-question' });
      wrap.appendChild(backHomeBar());
      wrap.appendChild(renderLabSettingsBar());
      if (Session.get().history.length > 0) wrap.appendChild(h('button', { class: 'dl-back', text: '← Back', onclick: () => { Session.goBack(); render(); } }));

      const headerRow = h('div', { class: 'dl-question-header' }, [
        dashImg('thinking', 'Dash reviewing a flavour analysis clipboard', 'dl-dash-thinking'),
        h('div', { class: 'dl-question-header-text' }, [
          q.dash ? h('p', { class: 'dl-dash-copy', text: q.dash }) : null,
          h('h2', { text: q.title })
        ])
      ]);
      wrap.appendChild(headerRow);

      if (questionId === 'drinkType') {
        wrap.appendChild(renderCategoryGrid(q.options));
        root.appendChild(wrap);
        return;
      }

      const optionsWrap = h('div', { class: 'dl-options-grid' });
      q.options.forEach((opt) => {
        const btn = h('button', { class: 'dl-option' }, [h('span', { class: 'dl-option-label', text: opt.label }), opt.sub ? h('span', { class: 'dl-option-sub', text: opt.sub }) : null]);
        btn.addEventListener('click', () => { if (opt.set) Session.applyAnswer(opt.set); Session.goTo(opt.next); render(); });
        optionsWrap.appendChild(btn);
      });
      wrap.appendChild(optionsWrap);
      root.appendChild(wrap);
    }

    function renderLoadingThenResult() {
      const session = Session.get();
      const messages = window.DrinkLab.LOADING_MESSAGES;
      const isGoose = session.intent.adventure === 'goose';
      const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const msgEl = h('p', { class: 'dl-loading-msg', text: messages[0] });
      const children = [
        dashImg('mixing', 'Dash actively mixing a drink experiment in the lab', 'dl-dash-mixing')
      ];
      if (!prefersReducedMotion) {
        children.push(h('div', { class: 'dl-fizz' }, [h('span', {}), h('span', {}), h('span', {}), h('span', {})]));
      }
      children.push(msgEl);
      const loadingEl = h('div', { class: 'dl-loading' }, children);
      root.appendChild(loadingEl);

      const duration = prefersReducedMotion ? 200 : window.DrinkLab.LOADING_DURATION_MS;
      let i = 0;
      const interval = prefersReducedMotion ? null : setInterval(() => {
        msgEl.classList.add('dl-msg-fade');
        setTimeout(() => {
          i = (i + 1) % messages.length;
          msgEl.textContent = messages[i];
          msgEl.classList.remove('dl-msg-fade');
        }, 150);
      }, Math.max(450, duration / messages.length));
      setTimeout(() => { if (interval) clearInterval(interval); computeAndRenderResult(isGoose); }, duration);
    }

    function computeAndRenderResult(isGoose) {
      const session = Session.get();
      const intent = session.intent;
      root.innerHTML = '';
      if (intent.drinkType === 'classic_soda') {
        const outcome = Engine.recommendClassicSoda(intent);
        if (!outcome.result) { renderNoResult(outcome); return; }
        renderClassicSodaResult(outcome, isGoose);
        return;
      }

      const outcome = Engine.recommend(intent);
      if (outcome.resultType === 'exact') {
        const recipe = outcome.result.recipe;
        Session.recordShown(recipe.id, recipe.heroProductId);
        renderRecipeDetail(recipe, outcome.hero, isGoose, 'exact', outcome.ranked, 'quiz');
      } else if (outcome.resultType === 'close_match' || outcome.resultType === 'dash_favorites') {
        renderChoicePicker(outcome, isGoose);
      } else {
        renderNoResult(outcome);
      }
    }

    function renderNoResult(outcome) {
      const children = [
        backHomeBar(),
        dashImg('error', 'Dash looking confused next to a failed experiment', 'dl-dash-error'),
        h('h2', { text: 'Dash needs one more variable.' }),
        h('div', { class: 'dl-no-result-actions' }, [
          h('button', { class: 'dl-cta', text: 'Change flavour direction', onclick: () => { Session.goBack(); render(); } }),
          h('button', { class: 'dl-cta-secondary', text: 'Go Wilder', onclick: () => { Session.applyAnswer({ adventure: 'goose' }); Session.goTo('result'); render(); } }),
          h('button', { class: 'dl-link-btn', text: 'Change answers', onclick: () => { Session.reset(); render(); } })
        ])
      ];
      if (isDebugMode() && outcome) children.push(renderDebugPanel(outcome.ranked, null, outcome.reason));
      root.appendChild(h('div', { class: 'dl-no-result' }, children));
    }

    function resultDashImage(isGoose) {
      return isGoose
        ? dashImg('goose', 'Dash in Unsupervised Goose Mode, mid-chaos with splashing syrups', 'dl-dash-goose')
        : dashImg('success', 'Dash giving a thumbs up while presenting the finished drink', 'dl-dash-success');
    }

    // Tier 2 ("close_match") and Tier 3 ("dash_favorites") land here: Dash
    // offers up to 3 real options instead of a dead end. Picking one opens
    // the same full recipe detail view as an exact match, just labelled
    // honestly for the tier it came from.
    function renderChoicePicker(outcome, isGoose) {
      const isFavorites = outcome.resultType === 'dash_favorites';
      const heading = isFavorites ? "Dash's Lab Favourites" : 'Dash has a few ideas.';
      const sub = isFavorites
        ? "Nothing matched perfectly, but these are tried-and-true picks from this category."
        : "None of these hit the mark exactly, but here's what's closest.";

      const grid = h('div', { class: 'dl-choice-grid' });
      outcome.candidates.forEach((candidate) => {
        const recipe = candidate.recipe;
        const card = h('button', { class: 'dl-choice-card' }, [
          h('span', { class: 'dl-choice-name', text: recipe.name }),
          h('span', { class: 'dl-choice-tags', text: recipe.primaryProfiles.join(' · ') }),
          h('span', { class: 'dl-choice-desc', text: recipe.description })
        ]);
        card.addEventListener('click', () => {
          Session.recordShown(recipe.id, recipe.heroProductId);
          root.innerHTML = '';
          renderRecipeDetail(recipe, candidate.hero, isGoose, outcome.resultType, outcome.ranked, 'quiz');
        });
        grid.appendChild(card);
      });

      const children = [
        backHomeBar(),
        dashImg(isFavorites ? 'success' : 'thinking', isFavorites ? 'Dash giving a thumbs up' : 'Dash reviewing options', isFavorites ? 'dl-dash-success' : 'dl-dash-thinking'),
        h('p', { class: 'dl-experiment-label', text: isFavorites ? "DASH'S LAB FAVOURITES" : 'CLOSE MATCHES' }),
        h('h1', { text: heading }),
        h('p', { class: 'dl-sub', text: sub }),
        grid,
        h('div', { class: 'dl-result-actions' }, [
          h('button', { class: 'dl-link-btn', text: 'Change answers', onclick: () => { Session.reset(); render(); } })
        ])
      ];
      if (isDebugMode()) children.push(renderDebugPanel(outcome.ranked, outcome.resultType, outcome.reason));
      root.appendChild(h('div', { class: 'dl-result dl-choice-screen' }, children));
    }

    function renderClassicSodaResult(outcome, isGoose) {
      const soda = outcome.result; const product = outcome.product;
      const accentColor = window.DrinkLab.CLASSIC_SODA_COLORS[soda.productKey] || window.DrinkLab.DEFAULT_FLAVOR_COLOR;
      const resultEl = h('div', { class: 'dl-result' }, [
        backHomeBar(),
        resultDashImage(isGoose),
        h('p', { class: 'dl-experiment-label', text: isGoose ? 'SOMEHOW, EXPERIMENT SUCCESSFUL' : 'EXPERIMENT SUCCESSFUL' }),
        h('h2', { text: 'DASH RECOMMENDS' }),
        h('h1', { text: soda.name.toUpperCase() }),
        renderHeroSection(product, soda.name, null, 'exact'),
        renderResultActions()
      ]);
      resultEl.style.setProperty('--dl-flavor-color', accentColor);
      root.appendChild(resultEl);
    }

    // Shared by Tier 1 (auto-rendered), the user picking a card out of
    // Tier 2/3 (renderChoicePicker), AND Search by Flavour result cards.
    // `resultType` drives only the label language, and `origin` drives
    // only which bottom-nav buttons appear — the recipe detail itself
    // (hero, ingredients, method, upgrade, lab pack) is identical
    // regardless of which discovery path got the customer here.
    function renderRecipeDetail(recipe, hero, isGoose, resultType, debugRanked, origin) {
      origin = origin || 'quiz';
      const accentColor = window.DrinkLab.FLAVOR_COLORS[recipe.heroProductId] || window.DrinkLab.DEFAULT_FLAVOR_COLOR;
      const labelText = resultType === 'close_match'
        ? 'A CLOSE MATCH'
        : resultType === 'dash_favorites'
          ? "DASH'S LAB FAVOURITE"
          : resultType === 'flavour_match'
            ? 'FOUND IT'
            : (isGoose ? 'SOMEHOW, EXPERIMENT SUCCESSFUL' : 'EXPERIMENT SUCCESSFUL');
      const resultEl = h('div', { class: 'dl-result' }, [
        backHomeBar(),
        resultDashImage(isGoose),
        h('p', { class: 'dl-experiment-label', text: labelText }),
        h('p', { class: 'dl-experiment-id', text: `EXPERIMENT ${recipe.id}` }),
        h('h1', { text: recipe.name.toUpperCase() }),
        h('p', { class: 'dl-taste-tags', text: recipe.primaryProfiles.join(' · ') }),
        h('blockquote', { class: 'dl-dash-quote', text: `"${recipe.dashQuote}"` }),
        renderWhyMatch(recipe, origin),
        renderHeroSection(hero, recipe.name, recipe, resultType),
        renderSecondaryProducts(recipe, resultType),
        renderRecipeCard(recipe),
        recipe.dashUpgrade ? renderDashUpgrade(recipe, resultType) : null,
        renderLabPack(recipe, resultType),
        origin === 'flavour' ? renderFlavourResultActions() : renderResultActions()
      ]);
      resultEl.style.setProperty('--dl-flavor-color', accentColor);
      root.appendChild(resultEl);
      if (isDebugMode()) root.appendChild(renderDebugPanel(debugRanked, resultType, null));
    }

    function renderWhyMatch(recipe, origin) {
      if (origin === 'flavour') {
        return h('div', { class: 'dl-why-match' }, [
          h('h3', { text: 'ABOUT THIS EXPERIMENT' }),
          h('p', { class: 'dl-description', text: recipe.description })
        ]);
      }
      const intent = Session.get().intent;
      const wanted = [].concat(intent.tasteProfiles || []).concat(intent.adventure ? [intent.adventure] : []);
      return h('div', { class: 'dl-why-match' }, [
        h('h3', { text: 'WHY THIS EXPERIMENT?' }),
        h('p', { text: 'You wanted: ' + wanted.join(', ') }),
        h('p', { text: `Dash chose: ${recipe.name.split(' ')[0]}` }),
        h('p', { class: 'dl-description', text: recipe.description })
      ]);
    }

    function renderHeroSection(ref, name, recipe, resultType) {
      if (!ref) return h('div', { class: 'dl-hero-missing' }, [h('p', { text: 'Dash misplaced the price tags.' })]);
      return h('div', { class: 'dl-hero' }, [
        h('h3', { text: 'THE STAR OF THE EXPERIMENT' }),
        ref.imageUrl ? h('img', { class: 'dl-hero-image', src: ref.imageUrl, alt: name, loading: 'lazy' }) : null,
        h('p', { class: 'dl-hero-name', text: name }),
        h('a', { class: 'dl-view-product', href: `/products/${ref.handle}`, text: 'View product' }),
        h('button', { class: 'button button-ATC', text: 'ADD TO CART', onclick: async (e) => {
          e.target.disabled = true; e.target.textContent = 'ADDING...';
          try { await Cart.addHeroToCart(ref, recipe ? recipe.id : 'classic_soda', name, resultType); e.target.textContent = '✓ ADDED TO YOUR LAB'; e.target.classList.add('dl-btn-success'); }
          catch (err) { e.target.textContent = 'Could not add — try again'; e.target.disabled = false; }
        } })
      ]);
    }

    function renderSecondaryProducts(recipe, resultType) {
      const heroKey = recipe.heroProductId;
      const upgradeKey = recipe.dashUpgrade && recipe.dashUpgrade.productId;
      const SYRUPS = window.DrinkLab.SHOPIFY_PRODUCTS || {};
      const SODAS = window.DrinkLab.CLASSIC_SODA_PRODUCTS || {};
      const seen = {};
      const extras = (recipe.ingredients || []).filter((ing) => {
        if (!ing.productId || ing.optional) return false;
        if (ing.productId === heroKey || ing.productId === upgradeKey) return false;
        if (seen[ing.productId]) return false;
        if (!SYRUPS[ing.productId] && !SODAS[ing.productId]) return false;
        seen[ing.productId] = true;
        return true;
      });
      if (!extras.length) return null;
      const sugarFree = Session.get().intent.sugarFreeOnly;
      const cards = extras.map((ing) => {
        // Classic sodas live in a separate product map; syrups fall back to
        // the default (SHOPIFY_PRODUCTS) source.
        const isSoda = !SYRUPS[ing.productId] && !!SODAS[ing.productId];
        const ref = Engine.resolveHeroReference(ing.productId, sugarFree, isSoda ? SODAS : undefined);
        if (!ref) return null;
        const name = displayName(ing.productId);
        return h('div', { class: 'dl-secondary-card' }, [
          h('a', { class: 'dl-secondary-link', href: `/products/${ref.handle}` }, [
            ref.imageUrl ? h('img', { class: 'dl-secondary-image', src: ref.imageUrl, alt: name, loading: 'lazy' }) : null,
            h('div', { class: 'dl-secondary-text' }, [
              h('span', { class: 'dl-secondary-name', text: name }),
              isSoda ? h('span', { class: 'dl-secondary-note', text: `Makes your ${name.toLowerCase()}` }) : null
            ])
          ]),
          h('button', { class: 'button button-ATC dl-secondary-add', text: 'ADD', onclick: async (e) => {
            e.target.disabled = true; e.target.textContent = 'ADDING...';
            try { await Cart.addUpgradeToCart(ref, recipe.id, resultType); e.target.textContent = '✓ ADDED'; e.target.classList.add('dl-btn-success'); }
            catch (err) { e.target.textContent = 'Try again'; e.target.disabled = false; }
          } })
        ]);
      }).filter(Boolean);
      if (!cards.length) return null;
      return h('div', { class: 'dl-secondary-products' }, [h('h3', { text: 'ALSO IN THIS EXPERIMENT' })].concat(cards));
    }

    function renderRecipeCard(recipe) {
      const ingredientItems = recipe.ingredients.map((ing) => h('li', { text: `${ing.amount ? ing.amount + ' ' : ''}${ing.ingredient}${ing.optional ? ' (optional)' : ''}` }));
      const stepItems = recipe.instructions.map((step) => h('li', { text: step }));
      return h('div', { class: 'dl-recipe-card' }, [h('h3', { text: 'MAKE THE EXPERIMENT' }), h('ul', { class: 'dl-ingredients' }, ingredientItems), h('ol', { class: 'dl-instructions' }, stepItems)]);
    }

    function renderDashUpgrade(recipe, resultType) {
      const upgradeRef = Engine.resolveHeroReference(recipe.dashUpgrade.productId, Session.get().intent.sugarFreeOnly);
      if (!upgradeRef) return null;
      return h('div', { class: 'dl-dash-upgrade' }, [
        h('h3', { text: "DASH'S UPGRADE" }),
        h('p', { text: `Add ${recipe.dashUpgrade.amount} ${recipe.dashUpgrade.productId.replace(/_/g, ' ')}.` }),
        h('p', { text: recipe.dashUpgrade.description }),
        h('button', { class: 'button button-ATC dl-upgrade-btn', text: '+ ADD UPGRADE', onclick: async (e) => {
          e.target.disabled = true;
          try { await Cart.addUpgradeToCart(upgradeRef, recipe.id, resultType); e.target.textContent = '✓ ADDED'; e.target.classList.add('dl-btn-success'); }
          catch (err) { e.target.disabled = false; }
        } })
      ]);
    }

    function renderLabPack(recipe, resultType) {
      const resolved = Engine.resolveLabPack(recipe.labPackId, Session.get().intent, recipe.heroProductId);
      if (!resolved || resolved.incomplete || !resolved.products) return null;
      const offer = window.DrinkLab.LAB_PACK_OFFER;
      const strip = h('div', { class: 'dl-lab-pack-strip' }, resolved.products.map((p) => {
        const name = p.key.replace(/_/g, ' ');
        const href = (p.ref && p.ref.handle) ? `/products/${p.ref.handle}` : '#';
        return h('a', { class: 'dl-lab-pack-item', href }, [
          (p.ref && p.ref.imageUrl) ? h('img', { class: 'dl-lab-pack-img', src: p.ref.imageUrl, alt: name, loading: 'lazy' }) : null,
          h('span', { class: 'dl-lab-pack-name', text: name })
        ]);
      }));
      return h('div', { class: 'dl-lab-pack' }, [
        h('h3', { text: 'TAKE THE EXPERIMENT FURTHER' }),
        h('h4', { text: resolved.pack.name.toUpperCase() }),
        strip,
        offer.enabled ? h('p', { class: 'dl-offer', text: offer.headline }) : null,
        h('button', { class: 'button button-ATC', text: 'ADD ALL 3', onclick: async (e) => {
          e.target.disabled = true; e.target.textContent = 'ADDING...';
          try { await Cart.addLabPackToCart(resolved.products.map((p) => p.ref), resolved.pack.id, resultType); e.target.textContent = '✓ ADDED TO YOUR LAB'; e.target.classList.add('dl-btn-success'); }
          catch (err) { e.target.textContent = 'Could not add — try again'; e.target.disabled = false; }
        } })
      ]);
    }

    function renderResultActions() {
      return h('div', { class: 'dl-result-actions' }, [
        h('button', { class: 'dl-cta', text: 'REMIX MY DRINK', onclick: () => { Session.excludeCurrentRecipe(); Session.goTo('result'); render(); } }),
        h('button', { class: 'dl-cta-secondary', text: 'GO WILDER', onclick: () => { Session.excludeCurrentRecipe(); Session.applyAnswer({ adventure: 'goose' }); Session.goTo('result'); render(); } }),
        h('button', { class: 'dl-link-btn', text: 'Change answers', onclick: () => { Session.reset(); render(); } })
      ]);
    }

    // Bottom nav for a recipe detail opened from Search by Flavour. REMIX
    // / GO WILDER don't make sense outside the quiz's adventure framing,
    // so this is a small, intentional variant — everything above it in
    // renderRecipeDetail is fully shared.
    function renderFlavourResultActions() {
      return h('div', { class: 'dl-result-actions' }, [
        h('button', { class: 'dl-cta', text: '← BACK TO RESULTS', onclick: () => { render(); } }),
        h('button', { class: 'dl-link-btn', text: 'Search a different flavour', onclick: () => { flavourSearchState.selectedKey = null; flavourSearchState.query = ''; render(); } })
      ]);
    }

    function isDebugMode() { return Engine.isDevPreviewDebug(); }

    function renderDebugPanel(ranked, resultType, reason) {
      const lines = (ranked || []).slice(0, 5).map((entry) => h('li', { text: `${entry.recipe.id} ${entry.recipe.name} — ${entry.score.total.toFixed(1)}` }));
      const meta = [];
      if (resultType) meta.push(h('p', { text: `resultType: ${resultType}` }));
      if (reason) meta.push(h('p', { text: `reason: ${reason}` }));
      return h('div', { class: 'dl-debug-panel' }, [
        h('h4', { text: 'DEBUG: ranked results' }),
        ...meta,
        h('ul', {}, lines),
        h('pre', { text: JSON.stringify(Session.get().intent, null, 2) })
      ]);
    }

    // ---------------- Search by Flavour ----------------

    function getFlavourAllowlist() {
      const products = window.DrinkLab.SHOPIFY_PRODUCTS || {};
      const sodas = window.DrinkLab.CLASSIC_SODA_PRODUCTS || {};
      const all = [];
      Object.keys(products).forEach((key) => { all.push({ key, label: displayName(key) }); });
      Object.keys(sodas).forEach((key) => { if (!products[key]) all.push({ key, label: displayName(key) }); });
      return all.sort((a, b) => a.label.localeCompare(b.label));
    }

    function getAlternativeRecipes(n) {
      const sugarFree = flavourSearchState.sugarFreeOnly;
      const pool = (window.DrinkLab.RECIPES || []).filter((r) => {
        if (r.testingStatus !== 'approved') return false;
        const entry = window.DrinkLab.SHOPIFY_PRODUCTS[r.heroProductId];
        if (!entry) return false;
        if (sugarFree && !entry.sugarFree) return false;
        return !!Engine.resolveHeroReference(r.heroProductId, sugarFree);
      });
      pool.sort((a, b) => (b.merchandisingBoost || 0) - (a.merchandisingBoost || 0));
      return pool.slice(0, n).map((r) => ({ recipe: r, hero: Engine.resolveHeroReference(r.heroProductId, sugarFree) }));
    }

    function renderFlavourSearchScreen() {
      const wrap = h('div', { class: 'dl-flavour-search' });
      wrap.appendChild(backHomeBar());
      wrap.appendChild(h('h2', { text: 'Search by Flavour' }));
      wrap.appendChild(h('p', { class: 'dl-sub', text: 'Already know your SIMPS syrup? Find every recipe that uses it.' }));

      const zeroToggle = h('div', { class: 'dl-zero-toggle' }, [
        h('span', { class: 'dl-zero-toggle-label', text: 'Zero Mode' }),
        h('label', { class: 'dl-switch' }, [
          h('input', Object.assign({ type: 'checkbox', onchange: (e) => {
            flavourSearchState.sugarFreeOnly = e.target.checked;
            if (flavourSearchState.selectedKey) renderFlavourResults(resultsContainer);
          } }, flavourSearchState.sugarFreeOnly ? { checked: 'checked' } : {})),
          h('span', { class: 'dl-switch-track' }),
          h('span', { class: 'dl-switch-thumb' })
        ])
      ]);
      wrap.appendChild(zeroToggle);

      const searchBox = h('div', { class: 'dl-flavour-searchbox' });
      const input = h('input', {
        type: 'text', class: 'dl-flavour-input',
        placeholder: 'Start typing a flavour, e.g. "Watermelon"...'
      });
      input.value = flavourSearchState.query;
      const dropdown = h('div', { class: 'dl-flavour-dropdown' });
      dropdown.style.display = 'none';

      function updateDropdown() {
        dropdown.innerHTML = '';
        const q = input.value.trim().toLowerCase();
        flavourSearchState.query = input.value;
        if (!q) { dropdown.style.display = 'none'; return; }
        const matches = getFlavourAllowlist().filter((f) => f.label.toLowerCase().indexOf(q) !== -1).slice(0, 8);
        if (matches.length === 0) { dropdown.style.display = 'none'; return; }
        dropdown.style.display = 'block';
        matches.forEach((f) => {
          const item = h('button', { class: 'dl-flavour-option', text: f.label });
          item.addEventListener('mousedown', (e) => { e.preventDefault(); });
          item.addEventListener('click', () => {
            flavourSearchState.selectedKey = f.key;
            flavourSearchState.query = f.label;
            flavourSearchState.groupFilter = 'all';
            render();
          });
          dropdown.appendChild(item);
        });
      }

      input.addEventListener('input', updateDropdown);
      input.addEventListener('focus', updateDropdown);
      input.addEventListener('blur', () => { setTimeout(() => { dropdown.style.display = 'none'; }, 150); });

      searchBox.appendChild(input);
      searchBox.appendChild(dropdown);
      wrap.appendChild(searchBox);

      const resultsContainer = h('div', { class: 'dl-flavour-results' });
      wrap.appendChild(resultsContainer);
      root.appendChild(wrap);

      if (flavourSearchState.selectedKey) renderFlavourResults(resultsContainer);
    }

    // Sensible profiles for the 3 classic sodas that have no CLASSIC_SODAS
    // entry (so they still get vibe-matched suggestions instead of a generic
    // popular fallback).
    var SODA_EXTRA_PROFILES = {
      tonic: ['bright', 'botanical', 'refreshing'],
      iced_tea: ['refreshing', 'bright', 'fruity'],
      lemonade: ['bright', 'tart', 'refreshing']
    };

    // "Similar vibe" recipes for a classic soda: match the soda's flavour
    // profile against recipe profiles, fall back to popular if nothing scores.
    function getSodaSimilarRecipes(key, n) {
      const sugarFree = flavourSearchState.sugarFreeOnly;
      const soda = (window.DrinkLab.CLASSIC_SODAS || []).find((s) => s.productKey === key);
      const profiles = (soda && soda.profiles) || SODA_EXTRA_PROFILES[key] || [];
      const eligible = (window.DrinkLab.RECIPES || []).filter((r) => {
        if (r.testingStatus !== 'approved') return false;
        // Recipes built ON this soda are shown in their own "Recipes with X"
        // section, so keep them out of the "similar vibe" list to avoid dupes.
        if (r.heroProductId === key) return false;
        if (sugarFree && !Engine.productAvailableFor(r.heroProductId, true)) return false;
        return !!Engine.resolveHeroReference(r.heroProductId, sugarFree);
      });
      const byPopular = () => eligible.slice().sort((a, b) => (b.merchandisingBoost || 0) - (a.merchandisingBoost || 0));
      let picks;
      if (profiles.length) {
        const scored = eligible.map((r) => {
          let s = 0;
          profiles.forEach((p) => {
            if ((r.primaryProfiles || []).indexOf(p) !== -1) s += 2;
            else if ((r.secondaryProfiles || []).indexOf(p) !== -1) s += 1;
          });
          return { r: r, s: s };
        }).filter((x) => x.s > 0);
        scored.sort((a, b) => (b.s - a.s) || ((b.r.merchandisingBoost || 0) - (a.r.merchandisingBoost || 0)));
        picks = scored.length ? scored.map((x) => x.r) : byPopular();
      } else {
        picks = byPopular();
      }
      return picks.slice(0, n).map((r) => ({ recipe: r, hero: Engine.resolveHeroReference(r.heroProductId, sugarFree) }));
    }

    // Recipes whose hero IS this soda (e.g. the Orange Cream sodas built on
    // LOCAL Orange Soda). Shown as a dedicated "Recipes with X" section.
    function getRecipesForHero(key, n) {
      const sugarFree = flavourSearchState.sugarFreeOnly;
      const recipes = (window.DrinkLab.RECIPES || []).filter((r) => {
        if (r.heroProductId !== key) return false;
        if (r.testingStatus !== 'approved') return false;
        if (sugarFree && !Engine.productAvailableFor(r.heroProductId, true)) return false;
        return !!Engine.resolveHeroReference(r.heroProductId, sugarFree);
      }).sort((a, b) => (b.merchandisingBoost || 0) - (a.merchandisingBoost || 0));
      return recipes.slice(0, n).map((r) => ({ recipe: r, hero: Engine.resolveHeroReference(r.heroProductId, sugarFree) }));
    }

    // Classic sodas (ginger beer, cola, etc.) live in their own bucket and
    // don't have flavour-search recipes. Instead of a dead end / generic
    // alternatives, route the customer to the soda itself + similar drinks +
    // the Soda Lab.
    function renderSodaSearchResult(container, key, label) {
      const sugarFree = flavourSearchState.sugarFreeOnly;
      const product = Engine.resolveHeroReference(key, sugarFree, window.DrinkLab.CLASSIC_SODA_PRODUCTS);
      const wrap = h('div', { class: 'dl-soda-result' }, [
        h('div', { class: 'dl-flavour-selected' }, [
          h('span', { class: 'dl-flavour-selected-label', text: `${label} — Classic Soda` }),
          h('button', { class: 'dl-link-btn', text: 'Change flavour', onclick: () => { flavourSearchState.selectedKey = null; flavourSearchState.query = ''; render(); } })
        ]),
        h('p', { class: 'dl-sub', text: `${label} is one of Dash's Classic Sodas. Grab it below, try a drink with a similar vibe, or build your own in the Soda Lab.` })
      ]);
      if (product) {
        wrap.appendChild(h('div', { class: 'dl-hero' }, [
          product.imageUrl ? h('a', { href: `/products/${product.handle}` }, [h('img', { class: 'dl-hero-image', src: product.imageUrl, alt: label, loading: 'lazy' })]) : null,
          h('p', { class: 'dl-hero-name', text: label }),
          h('a', { class: 'dl-view-product', href: `/products/${product.handle}`, text: 'View product' }),
          h('button', { class: 'button button-ATC', text: 'ADD TO CART', onclick: async (e) => {
            e.target.disabled = true; e.target.textContent = 'ADDING...';
            try { await Cart.addHeroToCart(product, 'classic_soda', label, 'flavour_match'); e.target.textContent = '✓ ADDED TO YOUR LAB'; e.target.classList.add('dl-btn-success'); }
            catch (err) { e.target.textContent = 'Could not add — try again'; e.target.disabled = false; }
          } })
        ]));
      }
      function recipeGrid(list) {
        const grid = h('div', { class: 'dl-choice-grid' });
        list.forEach((a) => {
          const recipe = a.recipe;
          const card = h('button', { class: 'dl-choice-card' }, [
            h('span', { class: 'dl-choice-name', text: recipe.name }),
            h('span', { class: 'dl-choice-tags', text: (recipe.primaryProfiles || []).join(' · ') }),
            h('span', { class: 'dl-choice-desc', text: recipe.description })
          ]);
          card.addEventListener('click', () => { root.innerHTML = ''; renderRecipeDetail(recipe, a.hero, false, 'flavour_match', null, 'flavour'); });
          grid.appendChild(card);
        });
        return grid;
      }

      const own = getRecipesForHero(key, 4);
      if (own.length) {
        wrap.appendChild(h('div', { class: 'dl-soda-similar' }, [h('h3', { text: `Recipes with ${label}` })]));
        wrap.appendChild(recipeGrid(own));
      }

      const sims = getSodaSimilarRecipes(key, 3);
      if (sims.length) {
        const simWrap = h('div', { class: 'dl-soda-similar' }, [h('h3', { text: 'Drinks with a similar vibe' })]);
        simWrap.appendChild(recipeGrid(sims));
        wrap.appendChild(simWrap);
      }
      wrap.appendChild(h('div', { class: 'dl-result-actions' }, [
        h('button', { class: 'dl-cta', text: 'BUILD A SODA IN THE LAB', onclick: () => {
          currentView = 'quiz'; Session.reset(); Session.applyAnswer({ drinkType: 'custom_soda' }); Session.goTo('sodaMission'); render();
        } })
      ]));
      container.appendChild(wrap);
    }

    function renderFlavourResults(container) {
      container.innerHTML = '';
      const key = flavourSearchState.selectedKey;
      const label = displayName(key);

      if (window.DrinkLab.CLASSIC_SODA_PRODUCTS[key] && !window.DrinkLab.SHOPIFY_PRODUCTS[key]) {
        renderSodaSearchResult(container, key, label);
        return;
      }

      container.appendChild(h('div', { class: 'dl-flavour-selected' }, [
        h('span', { class: 'dl-flavour-selected-label', text: `Showing recipes with SIMPS ${label}` }),
        h('button', { class: 'dl-link-btn', text: 'Change flavour', onclick: () => { flavourSearchState.selectedKey = null; flavourSearchState.query = ''; render(); } })
      ]));

      const matches = Engine.searchByFlavour(key, { sugarFreeOnly: flavourSearchState.sugarFreeOnly });

      if (matches.length === 0) {
        container.appendChild(h('div', { class: 'dl-flavour-empty' }, [
          dashImg('thinking', 'Dash checking his lab notes', 'dl-dash-thinking'),
          h('h3', { text: `No exact recipe for ${label} yet` }),
          h('p', { class: 'dl-sub', text: `Dash hasn't logged one with ${label} — but here are a few lab favourites worth experimenting with.` })
        ]));
        const alts = getAlternativeRecipes(4);
        if (alts.length) {
          const altGrid = h('div', { class: 'dl-choice-grid' });
          alts.forEach((a) => {
            const recipe = a.recipe;
            const card = h('button', { class: 'dl-choice-card' }, [
              h('span', { class: 'dl-choice-name', text: recipe.name }),
              h('span', { class: 'dl-choice-tags', text: (recipe.primaryProfiles || []).join(' · ') }),
              h('span', { class: 'dl-choice-desc', text: recipe.description })
            ]);
            card.addEventListener('click', () => {
              root.innerHTML = '';
              renderRecipeDetail(recipe, a.hero, false, 'flavour_match', null, 'flavour');
            });
            altGrid.appendChild(card);
          });
          container.appendChild(altGrid);
        }
        return;
      }

      const presentGroups = {};
      matches.forEach((m) => { presentGroups[searchGroupKey(m.recipe)] = true; });

      const chipsRow = h('div', { class: 'dl-flavour-chips' });
      const allChip = h('button', {
        class: 'dl-flavour-chip' + (flavourSearchState.groupFilter === 'all' ? ' dl-flavour-chip-active' : ''),
        text: `All (${matches.length})`
      });
      allChip.addEventListener('click', () => { flavourSearchState.groupFilter = 'all'; renderFlavourResults(container); });
      chipsRow.appendChild(allChip);

      SEARCH_GROUPS.forEach((g) => {
        if (!presentGroups[g.key]) return;
        const count = matches.filter((m) => searchGroupKey(m.recipe) === g.key).length;
        const style = (window.DrinkLab.CATEGORY_STYLES && window.DrinkLab.CATEGORY_STYLES[g.key]) || {};
        const chip = h('button', {
          class: 'dl-flavour-chip' + (flavourSearchState.groupFilter === g.key ? ' dl-flavour-chip-active' : ''),
          text: `${g.label} (${count})`
        });
        if (style.accent) chip.style.setProperty('--dl-chip-accent', style.accent);
        chip.addEventListener('click', () => { flavourSearchState.groupFilter = g.key; renderFlavourResults(container); });
        chipsRow.appendChild(chip);
      });
      container.appendChild(chipsRow);

      const visibleMatches = flavourSearchState.groupFilter === 'all'
        ? matches
        : matches.filter((m) => searchGroupKey(m.recipe) === flavourSearchState.groupFilter);

      const grid = h('div', { class: 'dl-flavour-result-grid' });
      visibleMatches.forEach((m) => { grid.appendChild(renderFlavourResultCard(m)); });
      container.appendChild(grid);
    }

    function renderFlavourResultCard(match) {
      const recipe = match.recipe;
      const groupLabel = searchGroupLabel(searchGroupKey(recipe));
      const tierBadgeText = match.tier === 'hero'
        ? 'HERO INGREDIENT'
        : match.tier === 'ingredient'
          ? 'REQUIRED INGREDIENT'
          : "DASH'S OPTIONAL UPGRADE";
      const card = h('button', { class: 'dl-flavour-card dl-flavour-card-' + match.tier }, [
        h('span', { class: 'dl-flavour-card-badge', text: tierBadgeText }),
        h('span', { class: 'dl-flavour-card-name', text: recipe.name }),
        h('span', { class: 'dl-flavour-card-meta', text: `${groupLabel} · ${(recipe.primaryProfiles || []).join(' · ')}` })
      ]);
      card.addEventListener('click', () => {
        root.innerHTML = '';
        renderRecipeDetail(recipe, match.hero, false, 'flavour_match', null, 'flavour');
      });
      return card;
    }

    render();
  }

  window.DrinkLab = window.DrinkLab || {};
  window.DrinkLab.mount = function (selector) {
    const root = document.querySelector(selector);
    if (!root) return;
    DrinkLabApp(root);
  };
})();